import React, { PureComponent } from 'react';
import * as dates from '@simplybenefits/sb-dates';
import Grid from '@mui/material/Grid';
import { helpers } from '@simplybenefits/sb-utils';
import Text from '../../components/Text.js';
import Button from '../../components/Button.js';
import Modal from '../../components/Modals/Modal.js';
import TextInput from '../../components/TextFields/TextInput.js';
import DateInput from '../../components/TextFields/DateInput.js';
import NumberInput from '../../components/TextFields/NumberInput.js';
import BubbleSelectBlock from '../../components/BubbleSelectBlock.js';
import Loader from '../../components/Loader.js';
import * as Theme from '../../theme/index.js';
import * as Services from '../../services/index.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
const genderMap = {
  male: 'Male',
  female: 'Female',
  other: 'Other'
};
const coverageTypeMap = {
  solo: 'Solo',
  duo: 'Duo',
  family: 'Family'
};
class CensusForm extends PureComponent {
  state = {
    firstname: '',
    lastname: '',
    email: '',
    birthdate: '',
    className: '',
    divisionName: '',
    hireDate: '',
    gender: '',
    title: '',
    coverageType: '',
    province: '',
    salary: '',
    hourlyWage: '',
    hoursPerWeek: '',
    language: i18n.t(tokens.dropdowns.languages.english),
    payrollID: '',
    isEdit: this.props.currentEmployee !== null,
    divisions: [],
    earningsType: '',
    showTerminationEffectiveDateDialog: false,
    showEffectiveDateDialog: false,
    effectiveDate: dates.getUTC(null, 'YYYY/MM/DD'),
    waiveEligibilityPeriod: null
  };
  componentDidMount() {
    if (this.state.isEdit) {
      const currentEmployee = this.props.currentEmployee;
      const employeeLanguage = currentEmployee.language === "fr" ? i18n.t(tokens.dropdowns.languages.french) : i18n.t(tokens.dropdowns.languages.english);
      this.setState({
        firstname: currentEmployee.firstname || '',
        lastname: currentEmployee.lastname || '',
        email: currentEmployee.email || '',
        birthdate: Services.dates.formatIncomingDate(currentEmployee.birthdate) || '',
        className: this.props.classData[currentEmployee.classID]?.title || '',
        divisionName: this.props.divisions[currentEmployee.divisionID]?.title || '',
        hireDate: Services.dates.formatIncomingDate(currentEmployee.hireDate) || '',
        gender: localizationMaps.fromEnglish("genders", currentEmployee.gender) || '',
        title: currentEmployee.title || '',
        coverageType: localizationMaps.fromEnglish("coverageTypes", currentEmployee.coverageType) || '',
        province: localizationMaps.fromEnglish("provinces", currentEmployee.province) || '',
        earningsType: localizationMaps.fromEnglish("earningsTypes", currentEmployee.earningsType) || '',
        salary: currentEmployee.salary || '',
        hourlyWage: currentEmployee.hourlyWage || '',
        hoursPerWeek: currentEmployee.hoursPerWeek || '',
        language: localizationMaps.fromEnglish("languages", employeeLanguage) || '',
        payrollID: currentEmployee.payrollID || '',
        waiveEligibilityPeriod: currentEmployee.waiveEligibilityPeriod || false
      });
    }
  }
  _validateEffectiveDate = async () => {
    if (this.state.isEdit && !this.props.isMasterSite) {
      let effectiveDateError = await Services.validateInput('effectiveDate', this.state.effectiveDate, i18n.locale);
      const startOfMonth = dates.getStartOfMonth();
      const effectiveDateUTC = dates.getUTC(this.state.effectiveDate);
      if (effectiveDateUTC < startOfMonth) {
        effectiveDateError = i18n.t(tokens.labels.employees.backdatedChanges);
      }
      await this.setState({
        effectiveDateError
      });
      if (effectiveDateError) {
        return false;
      }
      return true;
    }
    const effectiveDateError = await Services.validateInput('effectiveDate', this.state.effectiveDate, i18n.locale);
    await this.setState({
      effectiveDateError
    });
    if (effectiveDateError) {
      return false;
    }
    return true;
  };
  _validateForm = async () => {
    const firstnameError = await Services.validateInput('firstname', this.state.firstname);
    const lastnameError = await Services.validateInput('lastname', this.state.lastname);
    const emailError = await Services.validateInput('email', this.state.email);
    const birthdateError = await Services.validateInput('birthdate', this.state.birthdate, i18n.locale);
    const genderError = await Services.validateInput('gender', this.state.gender);
    const coverageTypeError = await Services.validateInput('coverageType', this.state.coverageType);
    const provinceError = await Services.validateInput('province', this.state.province);
    const hireDateError = await await Services.validateInput('hireDate', this.state.hireDate, i18n.locale);
    const earningsTypeError = await Services.validateInput('earningsType', this.state.earningsType);
    const titleError = await Services.validateInput('title', this.state.title);
    const classNameError = await Services.validateInput('selectClass', this.state.className);
    const divisionNameError = await Services.validateInput('selectDivision', this.state.divisionName);
    const hoursPerWeekError = await Services.validateInput('hoursPerWeek', this.state.hoursPerWeek);
    const waiveEligibilityPeriodError = this.props.currentAccountMeta === 1 && this.state.waiveEligibilityPeriod === null;
    let hourlyWageError = null;
    let salaryError = null;
    if (this.state.earningsType === 'Hourly') {
      hourlyWageError = await Services.validateInput('hourlyWage', this.state.hourlyWage);
    } else if (this.state.earningsType === 'Salary') {
      salaryError = await Services.validateInput('salary', this.state.salary);
    }
    await this.setState({
      firstnameError,
      lastnameError,
      emailError,
      birthdateError,
      genderError,
      coverageTypeError,
      provinceError,
      classNameError,
      divisionNameError,
      hireDateError,
      titleError,
      earningsTypeError,
      salaryError,
      hourlyWageError,
      hoursPerWeekError,
      waiveEligibilityPeriodError
    });
    if (firstnameError || lastnameError || emailError || birthdateError || genderError || coverageTypeError || provinceError || classNameError || divisionNameError || hireDateError || titleError || earningsTypeError || salaryError || hourlyWageError || hoursPerWeekError || waiveEligibilityPeriodError) {
      return false;
    }
    return true;
  };
  _saveEmployee = async () => {
    const isEffectiveDateValid = await this._validateEffectiveDate();
    if (!isEffectiveDateValid) {
      return false;
    }
    this._closeEffectiveDateDialog();
    const data = {
      firstname: this.state.firstname.trim(),
      lastname: this.state.lastname.trim(),
      email: this.state.email.trim(),
      birthdate: Services.dates.formatOutgoingDate(this.state.birthdate),
      hireDate: Services.dates.formatOutgoingDate(this.state.hireDate),
      gender: localizationMaps.toEnglish("genders", this.state.gender),
      coverageType: localizationMaps.toEnglish("coverageTypes", this.state.coverageType),
      province: localizationMaps.toEnglish("provinces", this.state.province),
      earningsType: localizationMaps.toEnglish("earningsTypes", this.state.earningsType),
      salary: this.state.salary !== '' ? Number(this.state.salary) : 0,
      hourlyWage: this.state.hourlyWage !== '' ? Number(this.state.hourlyWage) : 0,
      hoursPerWeek: this.state.hoursPerWeek !== '' ? Number(this.state.hoursPerWeek) : 0,
      language: localizationMaps.toEnglish("languages", this.state.language).toLowerCase() === "french" ? "fr" : "en",
      payrollID: this.state.payrollID === '' ? null : this.state.payrollID,
      classID: Object.keys(this.props.classData).find(key => this.props.classData[key].title === this.state.className),
      divisionID: Object.keys(this.props.divisions).find(key => this.props.divisions[key].title === this.state.divisionName),
      title: this.state.title,
      waiveEligibilityPeriod: this.state.waiveEligibilityPeriod || false,
      effectiveDate: dates.getUTC(this.state.hireDate)
    };
    const success = await this.props.addUser(data, this.props.accountID);
    if (success) {
      this._clear();
    }
    return null;
  };
  _editUser = async () => {
    const isEffectiveDateValid = await this._validateEffectiveDate();
    if (!isEffectiveDateValid) {
      return false;
    }
    this._closeEffectiveDateDialog();
    const data = {
      firstname: this.state.firstname.trim(),
      lastname: this.state.lastname.trim(),
      email: this.state.email.trim(),
      birthdate: Services.dates.formatOutgoingDate(this.state.birthdate),
      hireDate: Services.dates.formatOutgoingDate(this.state.hireDate),
      title: this.state.title,
      gender: localizationMaps.toEnglish("genders", this.state.gender),
      province: localizationMaps.toEnglish("provinces", this.state.province),
      earningsType: localizationMaps.toEnglish("earningsTypes", this.state.earningsType),
      salary: this.state.salary !== '' ? Number(this.state.salary) : 0,
      hourlyWage: this.state.hourlyWage !== '' ? Number(this.state.hourlyWage) : 0,
      hoursPerWeek: this.state.hoursPerWeek !== '' ? Number(this.state.hoursPerWeek) : 0,
      language: localizationMaps.toEnglish("languages", this.state.language).toLowerCase() === "french" ? "fr" : "en",
      payrollID: this.state.payrollID === '' ? null : this.state.payrollID,
      classID: Object.keys(this.props.classData).find(key => this.props.classData[key].title === this.state.className),
      divisionID: Object.keys(this.props.divisions).find(key => this.props.divisions[key].title === this.state.divisionName),
      coverageType: localizationMaps.toEnglish("coverageTypes", this.state.coverageType),
      effectiveDate: dates.getUTC(this.state.effectiveDate)
    };
    const success = await this.props.updateUser(data, this.props.currentEmployee.userID, this.props.accountID);
    if (success) {
      this._clear();
      if (this.props.onSave) {
        this.props.onSave();
      }
    }
    return null;
  };
  _showTerminationEffectiveDateDialog = () => {
    // if the account is not yet setup then we don't need to ask for an effective date
    if (Number(this.props.currentAccountMeta.state) === 0) {
      return this._terminateMember();
    }
    this.setState({
      showTerminationEffectiveDateDialog: true
    });
    return null;
  };
  _hideTerminationEffectiveDateDialog = () => {
    this.setState({
      showTerminationEffectiveDateDialog: false
    });
  };
  _clear = () => {
    this.setState({
      firstname: '',
      firstnameError: false,
      lastname: '',
      lastnameError: false,
      email: '',
      emailError: false,
      birthdate: '',
      birthdateError: false,
      className: '',
      classNameError: false,
      divisionName: '',
      divisionNameError: false,
      hireDate: '',
      hireDateError: false,
      gender: '',
      genderError: false,
      title: '',
      titleError: false,
      coverageType: '',
      coverageTypeError: false,
      province: '',
      provinceError: false,
      earningsType: '',
      earningsTypeError: false,
      salary: '',
      salaryError: false,
      hourlyWage: '',
      hourlyWageError: false,
      hoursPerWeek: '',
      hoursPerWeekError: false,
      divisions: [],
      effectiveDate: dates.getUTC(null, 'YYYY/MM/DD'),
      showTerminationEffectiveDateDialog: false,
      showEffectiveDateDialog: false,
      waiveEligibilityPeriod: null,
      waiveEligibilityPeriodError: false
    });
    this.props.close();
  };
  _handleInputChange = (type, value) => {
    this.setState({
      [type]: value
    });
  };
  _terminateMember = async () => {
    this._hideTerminationEffectiveDateDialog();
    const success = await this.props.removeUser(this.props.currentEmployee.userID, this.props.accountID, dates.getUTC(this.state.effectiveDate));
    if (success) {
      this._clear();
    }
  };

  /**
   * @returns {Promise<boolean>}
   * @private
   */
  _openEffectiveDateDialog = async () => {
    const isFormValid = await this._validateForm();
    if (!isFormValid) {
      return null;
    }

    // if the account is not yet setup then we don't need to ask for an effective date
    if (Number(this.props.currentAccountMeta.state) === 0 || Number(this.props.currentAccountMeta.state) === 3) {
      if (this.state.isEdit) {
        return this._editUser();
      }
      return this._saveEmployee();
    }

    // only show the effective date modal if it's a save and not for a create
    if (this.state.isEdit) {
      this.setState({
        showEffectiveDateDialog: true
      });
    } else {
      return this._saveEmployee();
    }
    return null;
  };
  _closeEffectiveDateDialog = () => {
    this.setState({
      showEffectiveDateDialog: false
    });
  };
  render() {
    const {
      classes,
      title,
      whitelabel,
      disableEditHireDate = false
    } = this.props;
    const disableHireDate = this.state.isEdit && disableEditHireDate;
    const styles = {
      contentBlock: {
        backgroundColor: Theme.colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        display: 'block',
        margin: 'auto auto 30px auto',
        padding: '30px',
        position: 'relative',
        zIndex: Theme.zIndex.container
      },
      newEmployeeSave: {
        marginLeft: '10px'
      }
    };
    let classData = [];

    // eslint-disable-next-line consistent-return, array-callback-return
    helpers.sortObjByTitle(this.props.classData).map(classID => {
      const data = this.props.classData[classID];

      // if its an edit and it's modular only show the non-parent classes
      if (this.state.isEdit && data.isModular && (data.parentClassID === null || data.parentClassID === "")) {
        return null;
      }

      // if its a new member we need to show the parent classes for modular flex
      if (!this.state.isEdit && data.isModular && data.parentClassID !== null && data.parentClassID !== "") {
        return null;
      }
      classData.push({
        key: classID,
        value: this.props.classData[classID].title
      });
    });
    const divisions = helpers.sortObjByTitle(this.props.divisions).filter(divisionID => this.props.divisions[divisionID].access !== 'Read').map(divisionID => ({
      key: divisionID,
      value: this.props.divisions[divisionID].title
    }));
    return /*#__PURE__*/React.createElement("div", {
      style: styles.contentBlock
    }, /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      display: "block",
      align: "left",
      margin: "20px 0",
      customLinkStyle: {
        lineHeight: '40px'
      }
    }, title), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.firstname),
      value: this.state.firstname,
      onChange: e => this._handleInputChange('firstname', e.target.value),
      error: Boolean(this.state.firstnameError),
      helperText: this.state.firstnameError,
      disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
      fullWidth: true,
      required: true,
      autoFocus: !this.state.isEdit
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.lastname),
      value: this.state.lastname,
      onChange: e => this._handleInputChange('lastname', e.target.value),
      error: Boolean(this.state.lastnameError),
      helperText: this.state.lastnameError,
      disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
      fullWidth: true,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.email),
      value: this.state.email,
      onChange: e => this._handleInputChange('email', e.target.value),
      error: Boolean(this.state.emailError),
      helperText: this.state.emailError,
      disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
      fullWidth: true,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(DateInput, {
      label: i18n.t(tokens.labels.account.dateOfBirthYYYYMMDD),
      value: this.state.birthdate,
      onChange: e => this._handleInputChange('birthdate', e.target.value),
      error: Boolean(this.state.birthdateError),
      helperText: this.state.birthdateError,
      disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
      fullWidth: true,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.class),
      value: this.state.className,
      onChange: e => this._handleInputChange('className', e.target.value),
      error: Boolean(this.state.classNameError),
      helperText: this.state.classNameError,
      fullWidth: true,
      required: true,
      select: true,
      selectOptions: [...classData],
      disabled: !this.props.isMasterSite && Boolean(this.state.isEdit && this.props.currentEmployee.parentClassID !== null) /* if the member has a parentClassID then it's a mod flex account and you cannot change the class  */
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.division),
      value: this.state.divisionName,
      onChange: e => this._handleInputChange('divisionName', e.target.value),
      error: Boolean(this.state.divisionNameError),
      helperText: this.state.divisionNameError,
      fullWidth: true,
      required: true,
      select: true,
      selectOptions: [...divisions]
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(DateInput, {
      label: i18n.t(tokens.labels.employees.hireDate),
      value: this.state.hireDate,
      onChange: e => this._handleInputChange('hireDate', e.target.value),
      error: Boolean(this.state.hireDateError),
      helperText: this.state.hireDateError,
      fullWidth: true,
      required: true,
      disabled: disableHireDate
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.gender),
      value: this.state.gender,
      onChange: e => this._handleInputChange('gender', e.target.value),
      error: Boolean(this.state.genderError),
      helperText: this.state.genderError,
      fullWidth: true,
      required: true,
      select: true,
      selectOptions: Services.selectFieldOptions.genderOptions()
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.occupation),
      value: this.state.title,
      onChange: e => this._handleInputChange('title', e.target.value),
      error: Boolean(this.state.titleError),
      helperText: this.state.titleError,
      fullWidth: true,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.individualDependents),
      value: this.state.coverageType,
      onChange: e => this._handleInputChange('coverageType', e.target.value),
      error: Boolean(this.state.coverageTypeError),
      helperText: this.state.coverageTypeError,
      fullWidth: true,
      required: true,
      select: true,
      disabled: Boolean(this.state.isEdit && this.props.currentEmployee.cert),
      selectOptions: Services.selectFieldOptions.coverageOptions()
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.provinceOfResidence),
      value: this.state.province,
      onChange: e => this._handleInputChange('province', e.target.value),
      error: Boolean(this.state.provinceError),
      helperText: this.state.provinceError,
      fullWidth: true,
      required: true,
      select: true,
      selectOptions: Services.selectFieldOptions.provinceOptions()
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.earningsType),
      value: this.state.earningsType,
      onChange: e => this._handleInputChange('earningsType', e.target.value),
      error: Boolean(this.state.earningsTypeError),
      helperText: this.state.earningsTypeError,
      fullWidth: true,
      required: true,
      select: true,
      selectOptions: Services.selectFieldOptions.earningsTypeOptions()
    })), localizationMaps.toEnglish("earningsTypes", this.state.earningsType) === 'Hourly' ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.employees.hourlyRate),
      prefix: "$ ",
      value: this.state.hourlyWage,
      onChange: e => this._handleInputChange('hourlyWage', e.target.value),
      error: Boolean(this.state.hourlyWageError),
      helperText: this.state.hourlyWageError,
      fullWidth: true,
      required: true
    })) : /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.employees.salary),
      prefix: "$ ",
      value: this.state.salary,
      onChange: e => this._handleInputChange('salary', e.target.value),
      error: Boolean(this.state.salaryError),
      helperText: this.state.salaryError,
      fullWidth: true,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.employees.hoursPerWeek),
      value: this.state.hoursPerWeek,
      onChange: e => this._handleInputChange('hoursPerWeek', e.target.value),
      error: Boolean(this.state.hoursPerWeekError),
      helperText: this.state.hoursPerWeekError,
      fullWidth: true,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.employeeLanguage),
      value: this.state.language,
      onChange: e => this._handleInputChange('language', e.target.value),
      fullWidth: true,
      required: true,
      select: true,
      selectOptions: Services.selectFieldOptions.languageOptions()
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.employees.payrollID),
      value: this.state.payrollID,
      onChange: e => this._handleInputChange('payrollID', e.target.value),
      fullWidth: true
    })),
    // we only allow this when the account is live, if it's pending or in revisions then it's census additions and should be waived automatically by the backend systems
    this.props.currentAccountMeta.status === 1 && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, !this.state.isEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      display: "block",
      align: "left",
      margin: "8px 0 4px"
    }, i18n.t(tokens.labels.employees.youMustChooseToWaive)), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      display: "block",
      align: "left",
      margin: "4px 0 8px"
    }, i18n.t(tokens.labels.employees.waivingMeansThat))) : /*#__PURE__*/React.createElement(Text, {
      medium: true,
      display: "block",
      align: "left",
      margin: "8px 0 4px"
    }, this.state.waiveEligibilityPeriod ? i18n.t(tokens.labels.employees.waitingPeriodWaived) : i18n.t(tokens.labels.employees.waitingPeriodNotWaived)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      customStyle: {
        marginTop: "8px",
        marginLeft: "8px"
      },
      allowToggleOff: true,
      first: {
        title: i18n.t(tokens.buttons.doNotWaive),
        selected: this.state.waiveEligibilityPeriod === false,
        field: 'doNotWaive',
        customStyle: {
          fontSize: 12
        }
      },
      second: {
        title: i18n.t(tokens.buttons.waive),
        selected: this.state.waiveEligibilityPeriod === true,
        field: 'waive',
        customStyle: {
          fontSize: 12
        }
      },
      handleChange: field => {
        if (!this.state.isEdit) {
          if (field === 'doNotWaive') {
            this._handleInputChange('waiveEligibilityPeriod', false);
          } else if (field === 'waive') {
            this._handleInputChange('waiveEligibilityPeriod', true);
          }
        }
      }
    })), this.state.waiveEligibilityPeriodError && /*#__PURE__*/React.createElement(Text, {
      medium: true,
      display: "block",
      align: "left",
      margin: "4px 0",
      color: "red"
    }, i18n.t(tokens.labels.employees.chooseToWaiveError))))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      style: {
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this._clear,
      transparent: true
    }, i18n.t(tokens.buttons.cancel)), this.state.isEdit && /*#__PURE__*/React.createElement(Button, {
      transparent: true,
      onClick: this._showTerminationEffectiveDateDialog
    }, i18n.t(tokens.buttons.terminate)), /*#__PURE__*/React.createElement(Button, {
      customStyle: styles.newEmployeeSave,
      onClick: this._openEffectiveDateDialog,
      color: "primary"
    }, i18n.t(tokens.buttons.save))), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showTerminationEffectiveDateDialog,
      onClose: this._hideTerminationEffectiveDateDialog,
      title: i18n.t(tokens.titles.setEffectiveDate),
      primaryButton: {
        label: i18n.t(tokens.buttons.terminate),
        onClick: this._terminateMember
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.employees.effectiveDateOfTermination)), /*#__PURE__*/React.createElement(DateInput, {
      label: i18n.t(tokens.labels.effectiveDate),
      value: this.state.effectiveDate,
      onChange: e => this._handleInputChange('effectiveDate', e.target.value),
      error: Boolean(this.state.effectiveDateError),
      helperText: this.state.effectiveDateError,
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.employees.byClickingThe), " ", /*#__PURE__*/React.createElement(Text, {
      customStyle: {
        display: 'inline'
      },
      medium: true,
      bold: true
    }, i18n.t(tokens.labels.employees.terminate)), " button below, the termination for ", /*#__PURE__*/React.createElement(Text, {
      customStyle: {
        display: 'inline'
      },
      medium: true,
      bold: true
    }, `${this.props.currentEmployee?.firstname} ${this.props.currentEmployee?.lastname}`), " ", i18n.t(tokens.labels.employees.willBeAppliedOnEffectiveDate))), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showEffectiveDateDialog,
      onClose: this._closeEffectiveDateDialog,
      title: i18n.t(tokens.titles.setEffectiveDate),
      primaryButton: {
        label: "Submit",
        onClick: this.state.isEdit ? this._editUser : this._saveEmployee
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.pleaseProvideEffectiveDate)), /*#__PURE__*/React.createElement(DateInput, {
      label: i18n.t(tokens.labels.effectiveDate),
      value: this.state.effectiveDate,
      onChange: e => this._handleInputChange('effectiveDate', e.target.value),
      error: Boolean(this.state.effectiveDateError),
      helperText: this.state.effectiveDateError,
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.changesAppliedOnEffectiveDate))), this.props.loader?.isLoading && this.props.loader.type === 'container' && /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    }), /*#__PURE__*/React.createElement("span", {
      id: "census-form"
    }));
  }
}
export default CensusForm;